interface IBook {
  user: string;
  userAccount: string;
  userUpdate: string;
  userPublicProfile: string;
  userOrders: string;
  needHelp: string;
  userChangePassword: string;
  confirmEmail: string;
  newsletter: string;
  jobs: {
    jobsListing: string;
    jobsPrepaid: string;
    jobsPrepaidDetail: (id?: string) => string,
    jobsApplicants: (id?: string) => string,
    jobsApplicantDetail: (eguid?: string, applicationId?: string) => string,
    postJobListing: string,
    editJob: (eguid?: string) => string,
    reactivateListing: (eguid?: string) => string,
    upgradeListing: (siteId?: number, eguid?: string) => string,
    postPrepaidListing: (guid?: string) => string,
    receipt: (eguid?: string) => string,
    noRemaining: string,
    prepaidExpired: string,
  },
  brands: {
    list: string,
    brandOptions: (id?: string) => string,
    editBrand: (brandGuid?: string) => string,
    createSubBrand: (brandGuid?: string) => string,
    editProducts: (brandGuid?: string) => string,
    createProduct: (brandGuid?: string) => string,
    editProductInfo: (brandGuid?: string, pguid?: string) => string,
    uploadProductPhotos: (brandGuid?: string, pguid?: string) => string,
    editProductDetails: (brandGuid?: string, pguid?: string) => string,
  },
  noshBrands: {
    hub: (brandGuid?: string) => string,
    edit: (brandGuid?: string) => string,
    products: (brandGuid?: string) => string,
    createProduct: (brandGuid?: string) => string,
    product: (brandGuid?: string, productGuid?: string) => string,
    createSubBrand: (brandGuid?: string) => string,
    whereToBuy: (brandGuid?: string) => string,
  },
  breweries: {
    list: string;
    edit: (guid?: string, section?: string) => string;
    newBeer: (guid?: string) => string;
    editBeer: (guid?: string, beerId?: string) => string;
  },
  marketplace: {
    listings: string,
  },
  magazine: {
    subscribe: string,
    renew: (guid:string) => string
  },
  invoices: {
    invoice: string,
    confirmEmail: string,
    invoiceCompleted: string
  },
  pressReleases: {
    pressReleases: string,
    upgrade: (guid?: string) => string,
    upgradeSuccess: string
  },
  submit: {
    pressReleases: {
      create: string
    },
  }
}
// /UpdateReview/EditBrand/

export const book: IBook = Object.freeze({
  user: '/user',
  userAccount: '/user/account',
  userUpdate: '/user/update',
  userPublicProfile: '/user/publicprofile',
  userOrders: '/user/orders',
  needHelp: '/help',
  userChangePassword: '/user/changepassword',
  confirmEmail: '/user/confirm-email',
  newsletter: '/user/newsletter',
  jobs: {
    jobsListing: '/user/jobslistings',
    jobsPrepaid: '/user/jobsprepaid',
    jobsPrepaidDetail: (id:string) => (id ? `/user/jobsprepaid/${id}` : '/user/jobsprepaid/:id'),
    jobsApplicants: (id:string) => (id ? `/user/jobsApplicants/${id}` : '/user/jobsApplicants/:id'),
    jobsApplicantDetail: (eguid: string, applicationId: string) => (eguid && applicationId ? `/user/jobsApplicantDetail/${eguid}/${applicationId}` : '/user/jobsApplicantDetail/:eguid/:applicationId'),
    postJobListing: '/user/jobs/post',
    editJob: (eguid?: string) => (eguid ? `/user/jobs/edit/${eguid}` : '/user/jobs/edit/:eguid'),
    reactivateListing: (eguid?: string) => (eguid ? `/user/jobs/reactivate/${eguid}` : '/user/jobs/reactivate/:eguid'),
    upgradeListing: (siteId?: number, eguid?: string) => (siteId && eguid ? `/user/jobs/upgrade/${siteId}/${eguid}` : '/user/jobs/upgrade/:siteId/:eguid'),
    postPrepaidListing: (guid?: string) => (guid ? `/user/jobs/prepaid/${guid}` : '/user/jobs/prepaid/:guid'),
    receipt: (eguid?: string) => (eguid ? `/user/jobs/receipt/${eguid}` : '/user/jobs/receipt/:eguid'),
    noRemaining: '/user/jobs/no-remaining',
    prepaidExpired: '/user/jobs/prepaid-expired',
  },
  brands: {
    list: '/brands',
    brandOptions: (id:string) => (id ? `/updatereview/${id}` : '/updatereview/:brandGuid'),
    editBrand: (id:string) => (id ? `/updatereview/EditBrand/${id}` : '/updatereview/EditBrand/:brandGuid'),
    editProducts: (id:string) => (id ? `/updatereview/EditProducts/${id}` : '/updatereview/EditProducts/:brandGuid'),
    createProduct: (id:string) => (id ? `/updatereview/CreateProduct/${id}` : '/updatereview/CreateProduct/:brandGuid'),
    createSubBrand: (id:string) => (id ? `/updatereview/CreateSubBrand/${id}` : '/updatereview/CreateSubBrand/:brandGuid'),
    editProductInfo: (bguid:string, pguid:string) => (bguid && pguid ? `/updatereview/editProductInfo/${bguid}/${pguid}` : '/updatereview/editProductInfo/:brandGuid/:productGuid'),
    uploadProductPhotos: (bguid:string, pguid:string) => (bguid && pguid ? `/updatereview/UploadProductPhotos/${bguid}/${pguid}` : '/updatereview/UploadProductPhotos/:brandGuid/:productGuid'),
    editProductDetails: (bguid:string, pguid:string) => (bguid && pguid ? `/updatereview/EditProductDetails/${bguid}/${pguid}` : '/updatereview/EditProductDetails/:brandGuid/:productGuid'),
  },
  noshBrands: {
    hub: (id?: string) => `/nosh/brands/${id || ':brandGuid'}`,
    edit: (id?: string) => `/nosh/brands/${id || ':brandGuid'}/edit`,
    products: (id?: string) => `/nosh/brands/${id || ':brandGuid'}/products`,
    createProduct: (id?: string) => `/nosh/brands/${id || ':brandGuid'}/products/new`,
    product: (id?: string, pguid?: string) => `/nosh/brands/${id || ':brandGuid'}/products/${pguid || ':productGuid'}`,
    createSubBrand: (id?: string) => `/nosh/brands/${id || ':brandGuid'}/subbrands/new`,
    whereToBuy: (id?: string) => `/nosh/brands/${id || ':brandGuid'}/where-to-buy`,
  },
  breweries: {
    list: '/breweries',
    edit: (guid?: string, section?: string) => `/breweries/${guid ? encodeURIComponent(guid) : ':breweryGuid'}/edit${section ? `/${section}` : guid ? '' : '/:section?'}`,
    newBeer: (guid?: string) => `/breweries/${guid ? encodeURIComponent(guid) : ':breweryGuid'}/beers/new`,
    editBeer: (guid?: string, beerId?: string) => `/breweries/${guid ? encodeURIComponent(guid) : ':breweryGuid'}/beers/${beerId ? encodeURIComponent(beerId) : ':beerId'}/edit`,
  },
  marketplace: {
    listings: '/user/marketplace',
  },
  magazine: {
    subscribe: 'https://magazine.bevnet.com/subscribe',
    renew: (guid:string) => (`https://magazine.bevnet.com/renew/${guid}`)
  },
  invoices: {
    invoice: '/invoice',
    confirmEmail: '/invoice/confirmEmail',
    invoiceCompleted: '/invoice/completed'
  },
  pressReleases: {
    pressReleases: '/user/press-releases',
    upgrade: (guid: string) => (guid ? `/user/press-releases/upgrade/${guid}` : '/user/press-releases/upgrade/:guid'),
    upgradeSuccess: '/user/press-releases/upgrade/:guid/success'
  },
  submit: {
    pressReleases: {
      create: 'https://submit.bevnet.com/news'
    },
  }
});
